import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getActiveChip } from "core-integration/src/store/chips/reducers";
import { getElementTypesBySquadPosition } from "core-integration/src/store/element-types/reducers";
import { updateElementTypeControl } from "core-integration/src/store/elements/thunks";
import {
  getProposedElements,
  getSavedPicks,
} from "core-integration/src/store/squad/reducers";
import {
  removeElement,
  restoreElement,
} from "core-integration/src/store/squad/thunks";
import ElementPlaceholderCard from "plos/src/components/ElementCard/ElementPlaceholderCard";
import PitchUnit from "plos/src/components/Pitch/PitchUnit";
import { useDispatch, useSelector } from "react-redux";
import SquadPitchElement from "../SquadPitchElement";
import { PitchCardProps } from "./types";

const SquadPitchUnit = ({
  elementValue,
  pos,
  renderElementMenu,
  handleOpenElemListSheet,
  pitchUnitRef,
}: PitchCardProps) => {
  const chip = useSelector(getActiveChip);
  const elementTypesByPosition = useSelector(getElementTypesBySquadPosition);
  const proposedElements = useSelector((state: RootState) =>
    getProposedElements(state, undefined, chip?.id),
  );
  const savedPicks = useSelector(getSavedPicks);
  const pick = savedPicks[pos];

  const dispatch = useDispatch<ThunkDispatch>();

  const showElementType = (elementTypeId: number) => {
    dispatch(updateElementTypeControl(elementTypeId));
  };

  const removeAndFilter = (pos: number) => {
    dispatch(removeElement(pos));
    showElementType(elementTypesByPosition[pos].thisType.id);
  };

  if (!elementTypesByPosition) {
    return null;
  }
  return (
    <PitchUnit pitchUnitRef={pitchUnitRef}>
      {proposedElements[pos] ? (
        <SquadPitchElement
          actionMe={() => removeAndFilter(pos)}
          elementId={proposedElements[pos].id}
          elementValue={elementValue}
          renderElementMenu={() => renderElementMenu(pos)}
          pick={pick}
        />
      ) : savedPicks[pos] ? (
        <SquadPitchElement
          actionMe={() => dispatch(restoreElement(pos))}
          elementId={savedPicks[pos].element}
          elementValue={elementValue}
          renderElementMenu={() => renderElementMenu(pos)}
          isRemoved={true}
          pick={pick}
        />
      ) : (
        <ElementPlaceholderCard
          elementType={elementTypesByPosition[pos].thisType}
          onPress={() => {
            showElementType(elementTypesByPosition[pos].thisType.id);
            handleOpenElemListSheet();
          }}
        />
      )}
    </PitchUnit>
  );
};

export default SquadPitchUnit;
